import React, { useEffect, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { Progress } from "reactstrap";
import { processes, toasterConfig } from "../../../utils/constants";
import "./index.scss";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { maxLoadTime, intervalTime } from "../../../utils/constants";
toast.configure();

const Bar = ({ action, filesize, setIsFileSizeLarge,uploadFileStatus,uploadFileStatusMessage,_counter }) => {
  const history = useHistory();
  const [progress, setProgress] = useState(0);
  const [counter, setCounter] = useState(0);
  const [process, setProcess] = useState("");

  /*
   * @function to set the value on progress bar while uploading file
   */
  const upload = useCallback(() => {
    setProgress((prev) => prev + 20);
    setCounter((prev) => prev + 1);
  
  }, []);

  /*useEffect(() => {
    let countInterval = setInterval(() => {
      const fileSizeMB = filesize / (1024 * 1024);
      if (progress >= 0 && progress < 100 && !action) {
        if (counter > 0 && fileSizeMB > maxLoadTime) {
          setIsFileSizeLarge(true);
        }
        upload();
      } else {
        clearInterval(countInterval);
        if (counter > 4) {
          toast.success("Document uploaded successful", toasterConfig);
          history.push("/documents");
        }
      }
    }, filesize / 1024 / 6);
    setProcess(processes[counter]);

    return () => clearInterval(countInterval);
  }, [counter, history, progress, action, upload]); */


  useEffect(() => {

    let countInterval = setInterval(() => {

      const fileSizeMB = filesize / (1024 * 1024);
      if (progress >= 0 && progress < 100 && !action) {
        if (counter > 0 && fileSizeMB > maxLoadTime) {
          setIsFileSizeLarge(true);
        }
        if (uploadFileStatus || progress === 0) {
          upload();
        }
      } else {
        clearInterval(countInterval);

        if (counter > 4) {
          toast.success(uploadFileStatusMessage, toasterConfig);
          history.push("/documents");
        }
      }
    }, intervalTime);
    setProcess(processes[counter]);
    _counter(counter)
    return () => clearInterval(countInterval);
    
  }, [counter, history, progress, action, upload, uploadFileStatus,uploadFileStatusMessage]);

  return (
    <>
      <div className="progress-blc d-flex">
        <div className="left-col flex-fill">
          <div className="row-cell">
            <Progress className="flex-fill" color="secondary" value={progress}>
              <span className="count">{progress}%</span>
            </Progress>
          </div>
          <div className="file-status-blc d-flex align-items-center">
            <span className="file-size">
              {Math.floor(filesize / (100 * 1024) / 10)}
              <span>MB</span>
            </span>
            <div className="file-status ms-auto">{process}</div>
          </div>
        </div>
        <span className="progress-value">
          {progress}
          <span>%</span>
        </span>
      </div>
    </>
  );
};

export default Bar;
